import { Flex, VFlex } from '@/components/base';
import Card from '@/components/Card/Card';
import Typo from '@/components/Typography/Typo';
import DateRangeDisplay from '@/features/(charts)/chart-detail/ui/date-range-display/date-range-display';
import {
  isWordCloudGraph,
} from '@/features/(charts)/chart-renderer/lib/word-cloud-basis';
import ChartRenderer from '@/features/(charts)/chart-renderer/ui/chart-renderer';
import useChartWordCloudItems from '@/features/(charts)/chart-renderer/ui/Single/use-chart-word-cloud-items';
import DashboardCardStyles from '@/features/Dashboard/components/styles/DashboardCardStyles';

import { TranslateLanguageSelect } from '../WordCloud/components/TranslateLanguageSelect';
import { WordCloud } from '../WordCloud/components/WordCloud';
import { useWordCloudTranslation } from '../WordCloud/hooks/useWordCloudTranslation';
import type { StaticChartItem } from './types';

type Props = {
  chart: StaticChartItem;
};

const { ChartWrapper, DashboardCardHeader } = DashboardCardStyles;

const StaticDashboard2Card = (props: Props) => {
  const { name } = props.chart;

  return (
    <Card
      className="break-inside-avoid"
      style={{ height: '100%' }}
      header={
        <DashboardCardHeader>
          <VFlex
            g={8}
            f={1}
            style={{
              cursor: 'pointer',
            }}
          >
            <Typo type="body0" weight="m" multilineEllipsis={2}>
              {name}
            </Typo>
          </VFlex>
        </DashboardCardHeader>
      }
      body={
        <VFlex g={16} f={1} style={{ height: '100%' }}>
          <ChartWrapper style={{ height: '100%' }}>
            <VFlex f={1} height="100%" g={16}>
              <ChartProvider chart={props.chart} />
              <DateRangeDisplay
                term={props.chart.target.term}
                compareTerm={props.chart.target.compare_term}
              />
            </VFlex>
          </ChartWrapper>
        </VFlex>
      }
    />
  );
};

const ChartProvider = (props: { chart: StaticChartItem }) => {
  const isWordCloudChart = isWordCloudGraph(props.chart.graph);
  const wordCloudData = useChartWordCloudItems({
    chart: props.chart,
    tableData: props.chart.tableData,
  });
  const {
    isSupported: isTranslationSupported,
    targetLanguage,
    setTargetLanguage,
    translatedWords,
    isTranslating,
  } = useWordCloudTranslation({
    words: wordCloudData,
    enabled: isWordCloudChart && wordCloudData.length > 0,
  });

  if (isWordCloudChart) {
    const hasWords = wordCloudData.length > 0;

    return (
      <VFlex f={1} style={{ overflow: 'hidden', height: '100%' }} g={8}>
        {isTranslationSupported && hasWords && (
          <Flex j="flex-end">
            <TranslateLanguageSelect
              value={targetLanguage}
              onChange={setTargetLanguage}
              isLoading={isTranslating}
            />
          </Flex>
        )}
        <WordCloud
          words={translatedWords}
          onWordClick={() => {}}
          isLoading={isTranslating}
        />
      </VFlex>
    );
  }
  return (
    <ChartRenderer
      chart={props.chart}
      tableData={props.chart.tableData}
      onHistoricalChange={() => {}}
    />
  );
};

export default StaticDashboard2Card;
